<template>
  <article ref="elRef" class="article-card relative" :style="style" @click="onClick">
    <template v-if="isMobile">
      <slot name="mobile" />
    </template>
    <template v-else @[isPreviewVideo&&`mouseover`]="emitHover(true)" @[isPreviewVideo&&`mouseleave`]="emitHover(false)">
      <slot name="desktop" />
    </template>
    <slot />
  </article>
</template>
<script>
// export const ArticleContainer = {
//   name: 'ArticleContainer',
// };

// // Proxy export all related components.
// export { default as ArticleTitle } from './ArticleTitle';
// export { default as ArticleCover } from './ArticleCover';
// export { default as ArticleHashtag } from './ArticleHashtag';
// export { default as ArticleDate } from './ArticleDate';
// export { default as ArticleCategory } from './ArticleCategory';
// export { default as ArticleBadge } from './ArticleBadge';

// // A Vue.js SFC must have a default export.
// export default ArticleContainer;
import { defineComponent, provide, computed, ref } from '@nuxtjs/composition-api';
import { useTracking } from '@/modules/tracking/composables/useTracking';
import { eventBus } from '~/modules/common/utils/eventBus';
import { useDevice } from '~/composables/useDevice';
import { onedioEvents } from '~/modules/tracking/scripts/onedioEvents';

export default defineComponent({
  props: {
    article: {
      type: Object,
      required: true,
    },
    deviceStyle: {
      type: Object,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: String,
      default: 'default',
    },
    dataLayer: {
      type: Object,
    },
    onedioEvent: {
      type: Object,
    },
  },
  setup(props) {
    provide('article', props.article);
    provide('articleData', props.data);
    provide('articleVariant', props.variant);
    let elRef = ref(null);
    let clickEvent;
    const { isMobile } = useDevice();
    const { sendDataLayer } = useTracking();
    const { sendDetaySidebarEvent } = onedioEvents();
    if (props.dataLayer) {
      ({ elRef, clickEvent } = sendDataLayer(
        {
          item: props.article,
          list: props.dataLayer?.name,
          type: props.dataLayer?.type,
          position: props.dataLayer?.position,
          listId: props.dataLayer?.listId,
        },
        props.dataLayer?.events || ['scroll', 'click']
      ));
    }
    const isPreviewVideo = computed(() => props.article?.preview || null);

    const emitHover = (status) => {
      eventBus.emit('playVideo', { status, id: props.article._id });
    };

    const style = computed(() => {
      if (isMobile.value) {
        return props.deviceStyle?.mobile;
      } else {
        return props.deviceStyle?.desktop;
      }
    });

    const onClick = (e) => {
      if (props.dataLayer) clickEvent(e, props.dataLayer.clickLabel);
      if (props.onedioEvent) {
        if (props.onedioEvent.type === 'sidebar') {
          sendDetaySidebarEvent(props.onedioEvent.category, props.onedioEvent.action, props.onedioEvent.label);
        }
      }
    };
    return { isMobile, style, elRef, clickEvent, isPreviewVideo, emitHover, onClick };
  },
});
</script>
